<div class="d-flex flex-column flex-md-row" id="dashboard-main-flex">
  <div id="calendar-holder" [hidden]="!showCalendar" class="p-4 h-vh-minus-header">
    <div id="calendar-holder-inner" class="px-2">
      <div  id="calendar-holder-inner-div">
        <div id="calendar" class="bg-white shadow-sm-darker text-primary-darker text-center text-xs inverted-agenda"></div>
        <hr class="mb-0" />
      </div>
      <div class="d-flex flex-column justify-content-evenly align-items-center pb-2 calendar-details" id="details" *ngIf="filterdEvents.length > 0">          
        <div class="rounded-md shadow-sm-darker eventcalendardetails">
          <div id="calenderupcomingeventsection" class="p-3" >
            <h3 class="text-center text-primary-darker">Upcoming Events <br> {{filterdEvents[0].start.substring(0, 10)}}</h3>
            <div *ngFor="let event of filterdEvents" class="p-2">
              <div class="rounded shadow-sm-darker">
                
                <div class="text-xs add-item-btn w-100 d-flex justify-content-between py-1 px-0" (click)="popupEvent(event)" >     
                  <div style="background-color: var(--primary-darker) !important; color: var(--subColor)" id="sticker">
                  </div>
                  <div class="p-2 flex-fill">
                    <div class="d-block">{{event.title}}</div>
                    <div style="font-size: xx-small;">                  
                      <span class="d-block">Start: {{util.formatDate(event.startdate)}}</span>
                      <span class="d-block" >End: {{util.formatDate(event.enddate)}}</span>   
                    </div>
                  </div>                                  
                </div>
              </div> 
              <hr class="m-0">
            </div>
          </div>
        </div>    
      </div>
      <div [hidden]="!showCalendar" class="pb-2 stickertextcontainer calendar-details" *ngIf="filterdEvents.length == 0">
        <p class="text-sm text-center align-middle">Tap/click on calender cell to view event(s) for that day. <br> Select sticker to see event details</p>             
      </div>
      <!-- <div [hidden]="showCalendar" style="flex-grow: 1;">There are no events on your calendar</div> -->
    </div>
  </div>  
  <div id="dashboardcourses" [hidden]="!showdashboard" class="flex-fill p-4 h-vh-minus-header">
    <h2 class="main-heading mb-3 pb-2">My Courses</h2>
      
    <p *ngIf="!this.headerinfo.pageloading && (!courses || courses.length === 0 )" class="font-italic mb-0">You Are Not Enrolled For Any Courses</p>
    <ul *ngIf="courses && courses.length > 0" class="progress-cards-wrap" id="coursessection">
      <li *ngFor="let course of courses">
        <app-moduleslistitem [module]="course" [fromDash]="true"></app-moduleslistitem>
      </li>
    </ul>
  </div>
  <div id="dashboardassessments" class="right-aside h-vh-minus-header shadow-sm-darker p-4 flex-shrink-0">
    <h2 class="main-heading m-0 pb-2">My Assessments</h2>
    <p *ngIf="!this.headerinfo.pageloading && (!assessments || assessments.length === 0 ) && pendingassignment" class="font-italic mt-3">No Pending Assessments</p>
    <ul *ngIf="assessments && assessments.length > 0" class="list-group list-group-flush">
      <li *ngFor="let assessment of assessments" class="list-group-item px-0 bg-transparent">
        <app-dashboarduserassessmentdetail [assessment]="assessment"></app-dashboarduserassessmentdetail>
      </li>
    </ul>
    <p class="text-center mt-3 mb-0"><a routerLink="/user/studentassessments" class="text-xs text-link">View All Assessments</a></p>
  </div>
</div>
<app-event-modal [eventDetail]="eventDetail"></app-event-modal>
